import ConsentCheckbox from "./ConsentCheckbox";
export default ConsentCheckbox;
